import React from 'react'

function barColor(pct) {
  if (pct >= 70) return '#639922'
  if (pct >= 50) return 'rgba(99, 153, 34, 0.7)'
  return '#BA7517'
}

export function PrepCardUsage({ cards = [] }) {
  if (!cards.length) {
    return <div style={styles.empty}>No prep submitted in this period.</div>
  }
  return (
    <div style={styles.wrap}>
      {cards.map((c) => (
        <div key={c.card} style={styles.row}>
          <div style={styles.header}>
            <span style={styles.label}>{c.label}</span>
            <span style={styles.pct}>{c.pct}%</span>
          </div>
          <div style={styles.track}>
            <div style={{ ...styles.fill, width: `${c.pct}%`, background: barColor(c.pct) }} />
          </div>
        </div>
      ))}
    </div>
  )
}

const styles = {
  wrap: { display: 'flex', flexDirection: 'column', gap: 8 },
  row: { display: 'flex', flexDirection: 'column', gap: 4 },
  header: { display: 'flex', justifyContent: 'space-between', fontSize: 12 },
  label: { color: 'var(--text-primary)' },
  pct: { fontWeight: 600, color: 'var(--text-primary)', fontVariantNumeric: 'tabular-nums' },
  track: { height: 6, background: 'var(--border)', borderRadius: 3, overflow: 'hidden' },
  fill: { height: '100%', borderRadius: 3 },
  empty: { fontSize: 12, color: 'var(--text-secondary)' },
}
